export class StepAction{
    action: string;
    actionStartTime: Date;
    actionPUID: string;
    actionRunTime: number;
    liquidHandler?: string = "";
    chemicals: Array<any> = [];
}